const citys={'浙江': ['杭州','宁波','舟山','嘉兴']};

export default{
  citys
}
